export const environment = {
  production: true,
  baseURL: 'https://hcportal.nabatisnack.co.id/api',
  // baseURL: 'https://staging.nabatisnack.co.id/hcportal/api',
  baseUrlGenba: 'https://genba-api.nabatisnack.co.id/api/v1',
  imagesURL: 'https://hcportal.nabatisnack.co.id/empdocument',
  // imagesURL: 'https://staging.nabatisnack.co.id/hcportal/empdocument',
  appName: 'Genba Self',
  appID: 'hcportalmobile'
};
